import styled from 'styled-components';
import {
  SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_LIGHT,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_600,
  SYS_BREAKPOINT_2_XL,
} from '@oneaudi/unified-web-common';
import { Text, TextProps } from '@oneaudi/unified-web-components';
import React from 'react';
import { dynamicStyling, dynamicStylingHelper } from '@oneaudi/vtp-shared';
import { SYS_SPACE_FIXED_500 } from '@oneaudi/unified-web-alpha-common';

export const SwitchNCUCWrapper = styled.div`
  padding-bottom: ${dynamicStylingHelper(SYS_SPACE_FIXED_600, SYS_SPACE_FIXED_500)};

  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    padding-bottom: ${SYS_SPACE_FIXED_600};
  }
`;

export const SwitchButtons = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: ${SYS_SPACE_FIXED_100};
}
`;

export const SubHeadText = styled((props) => <Text {...props} />)<TextProps>`
  ${dynamicStyling({
    legacy: `
          color: ${SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_LIGHT}`,
  })}
`;
